import React from "react";
import "./App.css";
import Hero from "./components/Hero/Hero";
import Navbar from "./components/Navbar/Navbar";
import About from "./components/About/About";
import Chatbot from "./components/Chatbot/Chatbot";
import Projects from "./components/Projects/Projects";
import Contact from "./components/Contact/Contact";
import Footer from "./components/Footer/Footer";
import OngoingProjects from "./components/OngoingProjects/OngoingProjects";
import ProjectVideos from "./components/ProjectVideos/ProjectVideos";
import Updates from "./components/Updates/Updates";
import Achievements from "./components/Achievements/Achievements";

function App() {
  return (
    <div className="App">
      <Navbar />


      <section id="hero">
        <Hero />
      </section>

      <section id="all-projects">
        <Projects />
      </section>

        <section id="all-projects">
        <Chatbot />
      </section>

      <section id="ongoing-projects">
        <OngoingProjects />
      </section>

      <section id="project-videos">
        <ProjectVideos />
      </section>

      <section id="about">
        <About />
      </section>

      <section id="contact">
        <Contact />
      </section>

      <section id="achievements">
        <Achievements />
      </section>

      {/* <section id="updates">
        <h2 style={{ color: "orange", textAlign: "center" }}>Updates</h2>
        <Updates />
      </section> */}

      <Footer />
    </div>
  );
}

export default App;
